var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _g2, _g3, _g4, _g5, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _line, _path39, _line2, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1406 12.6602H15.0532L19.4454 17.0523H22.2445",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7852 28.1458L13.4739 25.457H18.6088",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 49.1812H25.9361L30.0708 45.0465V37.8594",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9552 43.6588H42.8718L40.4748 41.2617H34.6016",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7441 31.1141L49.315 33.5432H46.0201L39.082 26.6055",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4168 13.4336H41.8357L36.7578 18.5114",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4141 8.39062L33.9252 9.90176V18.3327",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9577 39.4121H49.4405L46.9531 41.8991V45.4167L49.4405 47.9036H52.9577L55.4446 45.4167V41.8991L52.9577 39.4121Z",
    fill: "#F1F2FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9577 39.4121H49.4405L46.9531 41.8991V45.4167L49.4405 47.9036H52.9577L55.4446 45.4167V41.8991L52.9577 39.4121Z",
    stroke: "#BAAED1",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.317 1H27.7998L25.3125 3.48695V7.00454L27.7998 9.49149H31.317L33.804 7.00454V3.48695L31.317 1Z",
    fill: "#F1F2FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.317 1H27.7998L25.3125 3.48695V7.00454L27.7998 9.49149H31.317L33.804 7.00454V3.48695L31.317 1Z",
    stroke: "#BAAED1",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2008 9.36719H47.8637L45.5039 11.727V15.0641L47.8637 17.4239H51.2008L53.5606 15.0641V11.727L51.2008 9.36719Z",
    fill: "#F1F2FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2008 9.36719H47.8637L45.5039 11.727V15.0641L47.8637 17.4239H51.2008L53.5606 15.0641V11.727L51.2008 9.36719Z",
    stroke: "#BAAED1",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6331 10.0273H8.50027L6.99219 11.5354V13.6683L8.50027 15.1764H10.6331L12.1412 13.6683V11.5354L10.6331 10.0273Z",
    fill: "#F1F2FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6331 10.0273H8.50027L6.99219 11.5354V13.6683L8.50027 15.1764H10.6331L12.1412 13.6683V11.5354L10.6331 10.0273Z",
    stroke: "#BAAED1",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22836 17.9238H3.9392L3.02734 18.8353V20.1248L3.9392 21.0363H5.22836L6.13984 20.1248V18.8353L5.22836 17.9238Z",
    stroke: "#EFEDF4",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9588 5.03516H16.6697L15.7578 5.94663V7.23618L16.6697 8.14765H17.9588L18.8703 7.23618V5.94663L17.9588 5.03516Z",
    stroke: "#EFEDF4",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1737 49.5801H36.8845L35.9727 50.4916V51.7811L36.8845 52.6926H38.1737L39.0852 51.7811V50.4916L38.1737 49.5801Z",
    stroke: "#EFEDF4",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87289 44.9609H8.58373L7.67188 45.8724V47.162L8.58373 48.0734H9.87289L10.7844 47.162V45.8724L9.87289 44.9609Z",
    stroke: "#EFEDF4",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1463 3.0293H44.8572L43.9453 3.94078V5.23032L44.8572 6.14179H46.1463L47.0578 5.23032V3.94078L46.1463 3.0293Z",
    stroke: "#EFEDF4",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0877 20.7246H54.7986L53.8867 21.6361V22.9256L54.7986 23.8371H56.0877L56.9992 22.9256V21.6361L56.0877 20.7246Z",
    stroke: "#EFEDF4",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6253 26.7109H52.4925L50.9844 28.219V30.3519L52.4925 31.86H54.6253L56.1334 30.3519V28.219L54.6253 26.7109Z",
    fill: "#F1F2FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6253 26.7109H52.4925L50.9844 28.219V30.3519L52.4925 31.86H54.6253L56.1334 30.3519V28.219L54.6253 26.7109Z",
    stroke: "#BAAED1",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1527 46.4375H18.0198L16.5117 47.9456V50.0785L18.0198 51.5865H20.1527L21.6608 50.0785V47.9456L20.1527 46.4375Z",
    fill: "#F1F2FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1488 46.4375H18.0159L16.5078 47.9456V50.0785L18.0159 51.5865H20.1488L21.6568 50.0785V47.9456L20.1488 46.4375Z",
    stroke: "#BAAED1",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05784 26.418H4.33789L1 29.7555V34.4758L4.33789 37.8133H9.05784L12.3953 34.4758V29.7555L9.05784 26.418Z",
    fill: "#F1F2FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05784 26.418H4.33789L1 29.7555V34.4758L4.33789 37.8133H9.05784L12.3953 34.4758V29.7555L9.05784 26.418Z",
    stroke: "#BAAED1",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8499 29.3379H5.54913L3.92188 30.9648V33.2659L5.54913 34.8928H7.8499L9.47677 33.2659V30.9648L7.8499 29.3379Z",
    fill: "#BAAED1"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25561 30.7695H6.14006L5.35156 31.5584V32.6736L6.14006 33.4625H7.25561L8.04449 32.6736V31.5584L7.25561 30.7695Z",
    fill: "#BAAED1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.199997
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.115 3.89844H28.9994L28.2109 4.68732V5.80249L28.9994 6.59137H30.115L30.9039 5.80249V4.68732L30.115 3.89844Z",
    fill: "#BAAED1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.199997
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1072 27.8867H52.9916L52.2031 28.6756V29.7908L52.9916 30.5796H54.1072L54.896 29.7908V28.6756L54.1072 27.8867Z",
    fill: "#BAAED1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.199997
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7556 42.3105H50.6401L49.8516 43.0994V44.2146L50.6401 45.0035H51.7556L52.5445 44.2146V43.0994L51.7556 42.3105Z",
    fill: "#BAAED1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.199997
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3997 40.7559H49.9965L48.2969 42.4555V44.8586L49.9965 46.5582H52.3997L54.0992 44.8586V42.4555L52.3997 40.7559Z",
    fill: "#BAAED1"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5547 49.8378L32.7894 46.603V41.7285",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69922 23.8034H10.3299L13.9598 20.1738H20.3241",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 42.0142H15.9424L23.1519 34.8047",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3203 11.0293L21.729 12.438H27.0783L30.9074 16.267",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1211 30.0721L46.3225 23.8707V19.8262",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.293 17.0865L41.2895 11.09L38.2642 8.06508L41.7433 4.58594",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8815 43.6582L42.4871 46.0526H36.7578",
    stroke: "#E7E4EF",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8729 22.1797H17.0048L16.5117 23.6657V34.7892L24.3773 42.6544H35.5004L43.3656 34.7892V23.6657L42.8729 22.1797Z",
    fill: "#F1F2FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8729 22.1797H17.0048L16.5117 23.6657V34.7892L24.3773 42.6544H35.5004L43.3656 34.7892V23.6657L42.8729 22.1797Z",
    stroke: "#1B4458",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.497 42.6538L35.293 40.4707L35.497 42.6538Z",
    fill: "#F1F2FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35.7075,
    y1: 40.8163,
    x2: 35.8407,
    y2: 42.2413,
    stroke: "#1B4458",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 42.6558L24.5791 40.4727L24.375 42.6558Z",
    fill: "#F1F2FF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.9218,
    y1: 40.8852,
    x2: 24.7886,
    y2: 42.3102,
    stroke: "#1B4458",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2916 14.6035H24.5766L17 22.1801V32.8951L24.5766 40.4717H35.2916L42.8682 32.8951V22.1801L35.2916 14.6035Z",
    fill: "#F1F2FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2916 14.6035H24.5766L17 22.1801V32.8951L24.5766 40.4717H35.2916L42.8682 32.8951V22.1801L35.2916 14.6035Z",
    stroke: "#1B4458",
    strokeWidth: 0.761466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32.413 21.2109L26.1641 25.4527V27.3788L31.7228 29.9678H32.9449V27.9366L29.2099 25.5243L32.8079 25.3636V22.9779L32.413 21.2109Z",
    fill: "#D7DCFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M32.413 32.8748L26.1641 28.6285L32.413 24.3867L32.8082 26.1533L29.1102 28.6338L32.9434 31.1112L32.413 32.8748Z",
    fill: "#50B3FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8093 26.1533L32.4141 24.3867V22.2812L32.81 24.0479L32.8093 26.1533Z",
    fill: "#50B3FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M32.413 22.2812L26.1641 26.5241V28.6288L32.413 24.3867V22.2812Z",
    fill: "#BBDFFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1094 28.6346L32.9411 31.1121V29.0066L30.7062 27.5625L29.1094 28.6346Z",
    fill: "#BBDFFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.413 32.8748L26.1641 28.6285L32.413 24.3867L32.8082 26.1533L29.1102 28.6338L32.9434 31.1112L32.413 32.8748Z",
    stroke: "#1B4458",
    strokeWidth: 0.5711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8093 26.1533L32.4141 24.3867V22.2812L32.81 24.0479L32.8093 26.1533Z",
    stroke: "#1B4458",
    strokeWidth: 0.5711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M32.413 22.2812L26.1641 26.5241V28.6288L32.413 24.3867V22.2812Z",
    stroke: "#1B4458",
    strokeWidth: 0.5711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1094 28.6346L32.9411 31.1121V29.0066L30.7062 27.5625L29.1094 28.6346Z",
    stroke: "#1B4458",
    strokeWidth: 0.5711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinPrice);
export default __webpack_public_path__ + "static/media/coin_price.d7788f9465e9e63729a354a6e45b4a2e.svg";
export { ForwardRef as ReactComponent };